<app-card>
  <form id="profileForm" class="master" [formGroup]="profileForm" (ngSubmit)="onSubmit()">
    <div class="title">
      <span class="header-title">{{ 'masterdata' | translate }}</span>
      <button *ngIf="!isConsultantCv()" id="btn-cv-upload" mat-button color="primary"
              (click)="showCVParseModal()" type="button">
        {{ 'cv_upload' | translate }}
      </button>
    </div>
    <div class="info-area">
      <div class="img-container">
        <div class="img-area">
          <div *ngIf="!croppedImage && imgData && !editMode && !imageChangedEvent" class="crop-container">
            <img #image id="crop-image" [(src)]="imgData" crossorigin>
          </div>
          <div *ngIf="!imgData && !croppedImage" class="blankImage"></div>

          <input type="file"
                 style="display: none"
                 formControlName="image"
                 class="form-control"
                 accept=".jpg, .jpeg, .png, .gif"
                 #fileInput
                 (change)="fileChangeEvent($event)"/>
          <div *ngIf="imageChangedEvent || imgBase64" style="width: 152px;">
            <image-cropper
              *ngIf="showImageCropper && !editMode"
              [imageChangedEvent]="imageChangedEvent"
              [maintainAspectRatio]="true"
              [aspectRatio]="3 / 4"
              [resizeToWidth]="526"
              [resizeToHeight]="700"
              (imageCropped)="imageCropped($event)"
            ></image-cropper>
            <image-cropper
              *ngIf="editMode"
              [imageBase64]="imgBase64"
              [imageChangedEvent]="imageChangedEvent"
              [maintainAspectRatio]="true"
              [aspectRatio]="3 / 4"
              [resizeToWidth]="526"
              [resizeToHeight]="700"
              (imageCropped)="imageCropped($event)"
            ></image-cropper>
          </div>
        </div>
        <div class="buttons-row">
          <button mat-mini-fab
                  color="primary"
                  class="icon-button"
                  (click)="fileInput.click()"
                  matTooltip="{{'upload_img' | translate}}"
                  matTooltipPosition="below"
                  matTooltipShowDelay="700"
                  type="button">
            <mat-icon svgIcon="add_photo_alternate"></mat-icon>
          </button>
          <button mat-mini-fab
                  color="primary"
                  class="icon-button"
                  (click)="editImg()"
                  matTooltip="{{'edit_img' | translate}}"
                  matTooltipPosition="below"
                  matTooltipShowDelay="700"
                  type="button">
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
          <button mat-mini-fab
                  color="primary"
                  class="icon-button"
                  (click)="removeImg()"
                  matTooltip="{{'remove_img' | translate}}"
                  matTooltipPosition="below"
                  matTooltipShowDelay="700"
                  type="button">
            <mat-icon svgIcon="delete"></mat-icon>
          </button>
        </div>
      </div>
      <div class="info-form">
        <div class="basic-fields">
          <div class="grid-block">
            <mat-form-field appearance="outline" color="secondary">
              <mat-label>{{ 'title' | translate }}</mat-label>
              <input matInput formControlName="title" autocomplete="off" type="text" maxlength="20" formControlName="title">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'gender' | translate }}</mat-label>
              <mat-select formControlName="gender" matNativeControl required>
                  <mat-option *ngFor="let gender of genders" [value]="gender">{{ 'genders.' + gender | translate }}</mat-option>
              </mat-select>
              <mat-error *ngIf="profileForm.hasError('required', 'gender')">
                {{ 'required' | translate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'firstname' | translate }}</mat-label>
              <input matInput autocomplete="off" type="text" maxlength="40" minlength="2" formControlName="name" required>
              <mat-error *ngIf="profileForm.hasError('required', 'name')">
                {{ 'required' | translate }}
              </mat-error>
              <mat-error *ngIf="profileForm.hasError('minlength', 'name')">
                {{ 'min_lenght_validation' | translate: {'number': 2} }}
              </mat-error>
              <mat-error *ngIf="profileForm.hasError('maxlength', 'name')">
                {{ 'err_msg_maxlength' | translate: {'number': 40} }}
              </mat-error>
              <mat-error *ngIf="profileForm.hasError('pattern', 'name')">
                {{ 'pattern_validation' | translate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'lastname' | translate }}</mat-label>
              <input matInput autocomplete="off" type="text" maxlength="40" minlength="2" formControlName="lastname" required>
              <mat-error *ngIf="profileForm.hasError('required', 'lastname')">
                {{ 'required' | translate }}
              </mat-error>
              <mat-error *ngIf="profileForm.hasError('minlength', 'lastname')">
                {{ 'min_lenght_validation' | translate: {'number': 2} }}
              </mat-error>
              <mat-error *ngIf="profileForm.hasError('maxlength', 'lastname')">
                {{ 'err_msg_maxlength' | translate: {'number': 40} }}
              </mat-error>
              <mat-error *ngIf="profileForm.hasError('pattern', 'lastname')">
                {{ 'pattern_validation' | translate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'maritals' | translate }}</mat-label>
              <mat-select formControlName="marritalStatus" matNativeControl required>
                <mat-option *ngFor="let status of marritalStatuses" [value]="status">{{ 'marital_status.' + status | translate }}</mat-option>
              </mat-select>
              <mat-error *ngIf="profileForm.hasError('required', 'marritalStatus')">
                {{ 'required' | translate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'birthday' | translate }}</mat-label>
              <input matInput formControlName="birthday" [matDatepicker]="birthdayPicker" [max]="minAllowedDate">
              <mat-datepicker-toggle matIconSuffix [for]="birthdayPicker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar_month"></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #birthdayPicker></mat-datepicker>
              <mat-error *ngIf="profileForm.hasError('required', 'birthday')">
                {{ 'required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <hr class="divider">
          <div class="flex-block">
            <mat-form-field style="width: 263px;" appearance="outline">
              <mat-label>{{ 'role_greybee' | translate }}</mat-label>
              <mat-select formControlName="role" matNativeControl required>
                <mat-option *ngFor="let role of roles" [value]="role.name">{{'greybee_roles.' + role.name | translate}}{{isGermanFemale() ? 'in' : ''}}</mat-option>
              </mat-select>
              <mat-error *ngIf="profileForm.hasError('required', 'role')">
                {{ 'required' | translate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 263px;" appearance="outline">
              <mat-label>{{ 'employee_status' | translate }}</mat-label>
              <mat-select formControlName="userType" matNativeControl required>
                <mat-option *ngFor="let type of userTypes" [value]="type">{{ 'user_types.' + type | translate }}</mat-option>
              </mat-select>
              <mat-error *ngIf="profileForm.hasError('required', 'userType')">
                {{ 'required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <mat-form-field class="auto-height qualification-textarea" appearance="outline">
            <mat-label>{{ 'academic_degree' | translate }}</mat-label>
            <textarea
              matInput
              style="resize: none;"
              formControlName="qualification"
              maxlength="100"
              required
              rows="1">
            </textarea>
            <mat-error *ngIf="profileForm.hasError('required', 'qualification')">
              {{ 'required' | translate }}
            </mat-error>
            <mat-error *ngIf="profileForm.hasError('minlength', 'qualification')">
              {{ 'min_lenght_validation' | translate: {'number': 2} }}
            </mat-error>
            <mat-error *ngIf="profileForm.hasError('maxlength', 'qualification')">
              {{ 'err_msg_maxlength' | translate: {'number': 100} }}
            </mat-error>
            <mat-error *ngIf="profileForm.hasError('pattern', 'qualification')">
              {{ 'spaces_validation' | translate }}
            </mat-error>
          </mat-form-field>
          <div class="profile">
            <label id="profilelabel" for="profile" class="pl-1">{{'short_profile' | translate}}</label>
            <quill-editor
              id="profile"
              class="form-control quill-editor"
              name="profile"
              class="content-editor quill-editor-profile"
              [placeholder]="''"
              [modules]="modules"
              formControlName="profile"
              (onEditorCreated)='editorInit($event)'
            ></quill-editor>
            <span
              class="counter"
              [matTooltip]="'counter_tip_label' | translate"
              matTooltipPosition="below"
              matTooltipClass="info-tooltip-content">
              {{profileForm.controls.profile.value?.length || 0}} / 500
            </span>
            <small class="form-text error-text mt-0"
                   *ngIf="profileForm.get('profile')?.errors?.maxlength">
              {{ 'err_msg_maxlength' | translate: {'number': 500} }}
            </small>
          </div>
        </div>
      </div>
    </div>
    <section class="action-block">
      <button class="parse-button" mat-button type="submit" [disabled]="profileForm.invalid || imgLoading">
        {{ 'save_master_data_label' | translate }}
      </button>
    </section>

    <section class="errors-block">
      <mat-error *ngIf="profileForm.invalid || imgLoading">
        {{ 'there_are_mandatory_fields' | translate }}
      </mat-error>
    </section>
  </form>
</app-card>

